export default __webpack_public_path__ + "source-sans-pro-v11-latin-regular-96b158827eaacc5f7912648f2f99c752.bundle.woff2";